import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9c3b31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-kanban-filter-groupping-dropdown" }
const _hoisted_2 = { class: "task-kanban-filter-groupping-dropdown__target" }
const _hoisted_3 = { class: "task-kanban-filter-groupping-dropdown__target-text" }
const _hoisted_4 = { class: "task-kanban-filter-groupping-dropdown__option-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "task-kanban-filter-groupping-dropdown__option-text" }

import {
  QueueListIcon,
  ChevronDownIcon,
  StopCircleIcon,
  UserIcon,
  TagIcon,
  RectangleGroupIcon,
  UserCircleIcon,
  CrossLinedIcon,
  RectangleStackIcon,
} from "tir-style-system/icons/outline";
import { FlagIcon, StatusIcon } from "tir-style-system/icons/solid";
import { PropType, computed, onBeforeMount, ref } from "vue";
import { TasksKanbanGrouppingTypeEnum } from "../enums";
import { TirPmOptionList } from "tir-components";
import { TirPmScrollbar } from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'TasksKanbanFilterGrouppingDropdown',
  props: {
  modelValue: {
    type: Number as PropType<TasksKanbanGrouppingTypeEnum>,
    required: true,
  },
  /**Разрешено отсутствие группировки */
  allowNoneGroupping: { type: Boolean },
},
  emits: ["update:modelValue", "checkOpenOptionsFilterGroupping"],
  setup(__props, { emit: emits }) {

const props = __props;





const targetText = computed(() => {
  let grouppingName: string = "";

  switch (props.modelValue) {
    case TasksKanbanGrouppingTypeEnum.Status:
      grouppingName = "Статус";
      break;
    case TasksKanbanGrouppingTypeEnum.Performer:
      grouppingName = "Исполнитель";
      break;
    case TasksKanbanGrouppingTypeEnum.Priority:
      grouppingName = "Приоритет";
      break;
    case TasksKanbanGrouppingTypeEnum.Type:
      grouppingName = "Тип";
      break;
    case TasksKanbanGrouppingTypeEnum.Tag:
      grouppingName = "Тег";
      break;
    case TasksKanbanGrouppingTypeEnum.Author:
      grouppingName = "Автор";
      break;
    case TasksKanbanGrouppingTypeEnum.None:
      return "Без группировки";
  }

  return `Группировка по: ${grouppingName}`;
});

const options = ref([
  {
    GrouppingType: TasksKanbanGrouppingTypeEnum.Status,
    IconComponent: StatusIcon,
    Text: "Статус",
  },
  {
    GrouppingType: TasksKanbanGrouppingTypeEnum.Performer,
    IconComponent: UserCircleIcon,
    Text: "Исполнитель",
  },
  {
    GrouppingType: TasksKanbanGrouppingTypeEnum.Priority,
    IconComponent: FlagIcon,
    Text: "Приоритет",
  },
  {
    GrouppingType: TasksKanbanGrouppingTypeEnum.Tag,
    IconComponent: TagIcon,
    Text: "Тег",
  },
  {
    GrouppingType: TasksKanbanGrouppingTypeEnum.Type,
    IconComponent: RectangleStackIcon,
    Text: "Тип",
  },
  {
    GrouppingType: TasksKanbanGrouppingTypeEnum.Author,
    IconComponent: UserIcon,
    Text: "Автор",
  },
]);

/**Перед рендером */
onBeforeMount(() => {
  if (props.allowNoneGroupping) {
    options.value.unshift({
      GrouppingType: TasksKanbanGrouppingTypeEnum.None,
      IconComponent: CrossLinedIcon,
      Text: "Без",
    });
  }
});

/**
 * * Выбрать опцию
 * @param grouppingType
 */
const selectOption = (grouppingType: TasksKanbanGrouppingTypeEnum) => {
  emits("update:modelValue", grouppingType);
  // Клик вне компонента для закрытия
  document.body.click();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmOptionList), {
      width: 280,
      onCheckOpenOptions: _cache[0] || (_cache[0] = ($event: any) => (emits('checkOpenOptionsFilterGroupping', $event)))
    }, {
      optionListTarget: _withCtx(({ isOpened }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(QueueListIcon), { class: "task-kanban-filter-groupping-dropdown__target-icon" }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(targetText.value), 1),
          _createVNode(_unref(ChevronDownIcon), {
            class: _normalizeClass([
              'task-kanban-filter-groupping-dropdown__target-chevron',
              { 'is-opened': isOpened },
            ])
          }, null, 8, ["class"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(TirPmScrollbar), {
          class: "scrollbar",
          "show-on-hover": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "task-kanban-filter-groupping-dropdown__option",
                  key: option.GrouppingType,
                  onClick: ($event: any) => (selectOption(option.GrouppingType))
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(option.IconComponent), { class: "task-kanban-filter-groupping-dropdown__option-icon" })),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(option.Text), 1)
                ], 8, _hoisted_5))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})